import buildQuery, { Filter } from 'odata-query';
import {
    ODataResult,
    BroadcastMessageWithStatistic,
    BroadcastMessageVersion,
} from '../../../model';
import { convertToOdataOptions } from '../../../utils/odata';
import { createAppThunk } from '../../thunks';
import {
    fetchBroadcastMessagesApiCall,
    fetchBroadcastMessageVersions,
} from './broadcastMessageReportAPI';

export const loadBroadcastMessages = createAppThunk<
    ODataResult<BroadcastMessageWithStatistic[]>
>('broadcastMessageReport/loadBroadcastMessages', async (_, { getState }) => {
    const {
        sorting,
        pagination,
        filter: { queryText },
    } = getState().broadcastMessageReport;

    const options = convertToOdataOptions<BroadcastMessageWithStatistic>({
        count: pagination.currentPage === 1 && pagination.pageSize > 0,
        pagination: pagination,
        sorting: sorting,
    });

    const andParts: Partial<Filter<BroadcastMessageWithStatistic>>[] = [];

    if (queryText) {
        andParts.push({
            or: [
                { title: { contains: queryText } },
                { content: { contains: queryText } },
            ],
        });
    }

    options.filter = {
        and: [...andParts],
    };

    const query = buildQuery(options);

    return await fetchBroadcastMessagesApiCall(query);
});

export const loadBroadcastMessageVersions = createAppThunk<
    ODataResult<BroadcastMessageVersion[]>,
    string
>('broadcastMessageReport/messageVersions', async (messageId: string) => {
    const query = buildQuery({
        orderBy: 'createdOnUtc desc',
        top: 10,
    });

    return await fetchBroadcastMessageVersions(messageId, query);
});
